<flx-modal class="dark text-white bg-neutral-800">
  <div class="!flex-col">
    <h1 class="text-2xl font-bold text-center">Additional Feedback</h1>
    <h3 class="text-center text-neutral-400">
      Let us know what we can improve about the response:
    </h3>

    <div class="w-full mt-4">
      <div class="flex w-full">
        <flx-label class="grow !font-semibold flx-ds">Select an issue</flx-label>
      </div>
      <flx-choice-group
        [direction]="'column'"
        class="flex w-full mt-1 flx-ds"
        >
        @for (reason of feedbackReasons; track reason) {
          <flx-radio
            [clear]="true"
            [value]="reason"
            [formControl]="$any(feedbackFG.get('reason'))"
            [checked]="feedbackFG.get('reason').value === reason"
            >
            <flx-label>{{ reason }}</flx-label>
          </flx-radio>
        }
      </flx-choice-group>
    </div>

    <flx-textarea class="flx-ds flex w-full mt-4">
      <div class="flex w-full">
        <flx-label class="grow !font-semibold flx-ds mb-1">Extra details (optional)</flx-label>
      </div>

      <textarea
        [formControl]="$any(feedbackFG.get('message'))"
        class="w-full"
        placeholder="Add feedback..."
        flxTextarea
        type="text"
        cdkTextareaAutosize
        cdkAutosizeMinRows="2"
        cdkAutosizeMaxRows="3"
      ></textarea>
    </flx-textarea>

    <div class="w-full mt-3 flex flex-row justify-center items-center gap-4 text-sm font-semibold">
      <button
        (click)="closeModal()"
        class="flx-ds secondary w-full"
        flxButton
        >
        Cancel
      </button>
      <button
        [disabled]="feedbackFG.invalid"
        (click)="submitFeedback()"
        class="flx-ds primary w-full"
        flxButton
        >
        Send Feedback
      </button>
    </div>
  </div>
</flx-modal>
